export default "./fonts/survio-2w_f1-fonts-icomoon.woff";